// projects/humanresources-personnel/src/assets/i18n/*/hr-per-inst-faculty-branch.json
export class HrPerInstFacultyBranchKey {
    private static readonly keyPrefix = 'hrPerInstFacultyBranch';
    public static title = `${HrPerInstFacultyBranchKey.keyPrefix}.title`;
    public static Name = `${HrPerInstFacultyBranchKey.keyPrefix}.name`;
    public static faculty = `${HrPerInstFacultyBranchKey.keyPrefix}.faculty`;
}
